import type * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TranslatedFieldPartsFragment = { __typename?: 'TranslatedField', id: string, resourceId: string, field: string, text?: string | null, notes?: string | null, lastModifiedBy?: string | null, status: string, language: string };

export type GetTranslatedQuestionQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  language: Types.Scalars['String']['input'];
  includeDrafts?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetTranslatedQuestionQuery = { __typename?: 'RootQueryType', translatedQuestion?: { __typename?: 'TranslatedQuestion', id: string, meetsTranslationRequirements: boolean, translate: boolean, translateSupplements: boolean, requiredFields?: Array<string> | null, title?: string | null, prompt?: string | null, solutionText?: string | null, dropdownText?: string | null, dropdowns?: Array<any> | null, inputs?: Array<any> | null, sample?: string | null, options?: Array<any> | null, uncorrectedText?: string | null, snippetPrompt?: string | null, highlightPrompt?: string | null, headerLeft?: string | null, headerRight?: string | null, rows?: Array<any> | null, translatedFields: Array<{ __typename?: 'TranslatedField', id: string, resourceId: string, field: string, text?: string | null, notes?: string | null, lastModifiedBy?: string | null, status: string, language: string }> } | null };

export type GetTranslatedSupplementQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  language: Types.Scalars['String']['input'];
  includeDrafts?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetTranslatedSupplementQuery = { __typename?: 'RootQueryType', translatedSupplement?: { __typename?: 'TranslatedSupplement', id: string, translate: boolean, meetsTranslationRequirements: boolean, requiredFields?: Array<string> | null, name?: string | null, content?: any | null, translatedFields: Array<{ __typename?: 'TranslatedField', id: string, resourceId: string, field: string, text?: string | null, notes?: string | null, lastModifiedBy?: string | null, status: string, language: string }> } | null };

export type GetTranslationJobQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetTranslationJobQuery = { __typename?: 'RootQueryType', translationJob?: { __typename?: 'TranslationJob', id: string, status: string } | null };

export type CreateTranslationJobMutationVariables = Types.Exact<{
  input: Types.CreateTranslationJobInput;
}>;


export type CreateTranslationJobMutation = { __typename?: 'RootMutationType', createTranslationJob: { __typename?: 'CreateTranslationJobResult', result?: { __typename?: 'TranslationJob', id: string, status: string } | null, errors: Array<{ __typename?: 'MutationError', message?: string | null }> } };

export type UpsertTranslatedQuestionFieldMutationVariables = Types.Exact<{
  input: Types.UpsertTranslatedQuestionFieldInput;
}>;


export type UpsertTranslatedQuestionFieldMutation = { __typename?: 'RootMutationType', upsertTranslatedQuestionField: { __typename?: 'UpsertTranslatedQuestionFieldResult', errors: Array<{ __typename?: 'MutationError', message?: string | null }> } };

export type UpsertTranslatedSupplementFieldMutationVariables = Types.Exact<{
  input: Types.UpsertTranslatedSupplementFieldInput;
}>;


export type UpsertTranslatedSupplementFieldMutation = { __typename?: 'RootMutationType', upsertTranslatedSupplementField: { __typename?: 'UpsertTranslatedSupplementFieldResult', errors: Array<{ __typename?: 'MutationError', message?: string | null }> } };

export const TranslatedFieldPartsFragmentDoc = gql`
    fragment TranslatedFieldParts on TranslatedField {
  id
  resourceId
  field
  text
  notes
  lastModifiedBy
  status
  language
}
    `;
export const GetTranslatedQuestionDocument = gql`
    query GetTranslatedQuestion($id: ID!, $language: String!, $includeDrafts: Boolean) {
  translatedQuestion(id: $id, language: $language, includeDrafts: $includeDrafts) {
    id
    meetsTranslationRequirements
    translate
    translateSupplements
    requiredFields
    title
    prompt
    solutionText
    dropdownText
    dropdowns
    inputs
    sample
    options
    uncorrectedText
    snippetPrompt
    highlightPrompt
    headerLeft
    headerRight
    rows
    translatedFields {
      ...TranslatedFieldParts
    }
  }
}
    ${TranslatedFieldPartsFragmentDoc}`;

/**
 * __useGetTranslatedQuestionQuery__
 *
 * To run a query within a React component, call `useGetTranslatedQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslatedQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslatedQuestionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *      includeDrafts: // value for 'includeDrafts'
 *   },
 * });
 */
export function useGetTranslatedQuestionQuery(baseOptions: Apollo.QueryHookOptions<GetTranslatedQuestionQuery, GetTranslatedQuestionQueryVariables> & ({ variables: GetTranslatedQuestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTranslatedQuestionQuery, GetTranslatedQuestionQueryVariables>(GetTranslatedQuestionDocument, options);
      }
export function useGetTranslatedQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTranslatedQuestionQuery, GetTranslatedQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTranslatedQuestionQuery, GetTranslatedQuestionQueryVariables>(GetTranslatedQuestionDocument, options);
        }
// @ts-ignore
export function useGetTranslatedQuestionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTranslatedQuestionQuery, GetTranslatedQuestionQueryVariables>): Apollo.UseSuspenseQueryResult<GetTranslatedQuestionQuery, GetTranslatedQuestionQueryVariables>;
export function useGetTranslatedQuestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTranslatedQuestionQuery, GetTranslatedQuestionQueryVariables>): Apollo.UseSuspenseQueryResult<GetTranslatedQuestionQuery | undefined, GetTranslatedQuestionQueryVariables>;
export function useGetTranslatedQuestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTranslatedQuestionQuery, GetTranslatedQuestionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTranslatedQuestionQuery, GetTranslatedQuestionQueryVariables>(GetTranslatedQuestionDocument, options);
        }
export type GetTranslatedQuestionQueryHookResult = ReturnType<typeof useGetTranslatedQuestionQuery>;
export type GetTranslatedQuestionLazyQueryHookResult = ReturnType<typeof useGetTranslatedQuestionLazyQuery>;
export type GetTranslatedQuestionSuspenseQueryHookResult = ReturnType<typeof useGetTranslatedQuestionSuspenseQuery>;
export type GetTranslatedQuestionQueryResult = Apollo.QueryResult<GetTranslatedQuestionQuery, GetTranslatedQuestionQueryVariables>;
export const GetTranslatedSupplementDocument = gql`
    query GetTranslatedSupplement($id: ID!, $language: String!, $includeDrafts: Boolean) {
  translatedSupplement(
    id: $id
    language: $language
    includeDrafts: $includeDrafts
  ) {
    id
    translate
    meetsTranslationRequirements
    requiredFields
    name
    content
    translatedFields {
      ...TranslatedFieldParts
    }
  }
}
    ${TranslatedFieldPartsFragmentDoc}`;

/**
 * __useGetTranslatedSupplementQuery__
 *
 * To run a query within a React component, call `useGetTranslatedSupplementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslatedSupplementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslatedSupplementQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *      includeDrafts: // value for 'includeDrafts'
 *   },
 * });
 */
export function useGetTranslatedSupplementQuery(baseOptions: Apollo.QueryHookOptions<GetTranslatedSupplementQuery, GetTranslatedSupplementQueryVariables> & ({ variables: GetTranslatedSupplementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTranslatedSupplementQuery, GetTranslatedSupplementQueryVariables>(GetTranslatedSupplementDocument, options);
      }
export function useGetTranslatedSupplementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTranslatedSupplementQuery, GetTranslatedSupplementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTranslatedSupplementQuery, GetTranslatedSupplementQueryVariables>(GetTranslatedSupplementDocument, options);
        }
// @ts-ignore
export function useGetTranslatedSupplementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTranslatedSupplementQuery, GetTranslatedSupplementQueryVariables>): Apollo.UseSuspenseQueryResult<GetTranslatedSupplementQuery, GetTranslatedSupplementQueryVariables>;
export function useGetTranslatedSupplementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTranslatedSupplementQuery, GetTranslatedSupplementQueryVariables>): Apollo.UseSuspenseQueryResult<GetTranslatedSupplementQuery | undefined, GetTranslatedSupplementQueryVariables>;
export function useGetTranslatedSupplementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTranslatedSupplementQuery, GetTranslatedSupplementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTranslatedSupplementQuery, GetTranslatedSupplementQueryVariables>(GetTranslatedSupplementDocument, options);
        }
export type GetTranslatedSupplementQueryHookResult = ReturnType<typeof useGetTranslatedSupplementQuery>;
export type GetTranslatedSupplementLazyQueryHookResult = ReturnType<typeof useGetTranslatedSupplementLazyQuery>;
export type GetTranslatedSupplementSuspenseQueryHookResult = ReturnType<typeof useGetTranslatedSupplementSuspenseQuery>;
export type GetTranslatedSupplementQueryResult = Apollo.QueryResult<GetTranslatedSupplementQuery, GetTranslatedSupplementQueryVariables>;
export const GetTranslationJobDocument = gql`
    query GetTranslationJob($id: ID!) {
  translationJob(id: $id) {
    id
    status
  }
}
    `;

/**
 * __useGetTranslationJobQuery__
 *
 * To run a query within a React component, call `useGetTranslationJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslationJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslationJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTranslationJobQuery(baseOptions: Apollo.QueryHookOptions<GetTranslationJobQuery, GetTranslationJobQueryVariables> & ({ variables: GetTranslationJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTranslationJobQuery, GetTranslationJobQueryVariables>(GetTranslationJobDocument, options);
      }
export function useGetTranslationJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTranslationJobQuery, GetTranslationJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTranslationJobQuery, GetTranslationJobQueryVariables>(GetTranslationJobDocument, options);
        }
// @ts-ignore
export function useGetTranslationJobSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTranslationJobQuery, GetTranslationJobQueryVariables>): Apollo.UseSuspenseQueryResult<GetTranslationJobQuery, GetTranslationJobQueryVariables>;
export function useGetTranslationJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTranslationJobQuery, GetTranslationJobQueryVariables>): Apollo.UseSuspenseQueryResult<GetTranslationJobQuery | undefined, GetTranslationJobQueryVariables>;
export function useGetTranslationJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTranslationJobQuery, GetTranslationJobQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTranslationJobQuery, GetTranslationJobQueryVariables>(GetTranslationJobDocument, options);
        }
export type GetTranslationJobQueryHookResult = ReturnType<typeof useGetTranslationJobQuery>;
export type GetTranslationJobLazyQueryHookResult = ReturnType<typeof useGetTranslationJobLazyQuery>;
export type GetTranslationJobSuspenseQueryHookResult = ReturnType<typeof useGetTranslationJobSuspenseQuery>;
export type GetTranslationJobQueryResult = Apollo.QueryResult<GetTranslationJobQuery, GetTranslationJobQueryVariables>;
export const CreateTranslationJobDocument = gql`
    mutation CreateTranslationJob($input: CreateTranslationJobInput!) {
  createTranslationJob(input: $input) {
    result {
      id
      status
    }
    errors {
      message
    }
  }
}
    `;
export type CreateTranslationJobMutationFn = Apollo.MutationFunction<CreateTranslationJobMutation, CreateTranslationJobMutationVariables>;

/**
 * __useCreateTranslationJobMutation__
 *
 * To run a mutation, you first call `useCreateTranslationJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTranslationJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTranslationJobMutation, { data, loading, error }] = useCreateTranslationJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTranslationJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateTranslationJobMutation, CreateTranslationJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTranslationJobMutation, CreateTranslationJobMutationVariables>(CreateTranslationJobDocument, options);
      }
export type CreateTranslationJobMutationHookResult = ReturnType<typeof useCreateTranslationJobMutation>;
export type CreateTranslationJobMutationResult = Apollo.MutationResult<CreateTranslationJobMutation>;
export type CreateTranslationJobMutationOptions = Apollo.BaseMutationOptions<CreateTranslationJobMutation, CreateTranslationJobMutationVariables>;
export const UpsertTranslatedQuestionFieldDocument = gql`
    mutation UpsertTranslatedQuestionField($input: UpsertTranslatedQuestionFieldInput!) {
  upsertTranslatedQuestionField(input: $input) {
    errors {
      message
    }
  }
}
    `;
export type UpsertTranslatedQuestionFieldMutationFn = Apollo.MutationFunction<UpsertTranslatedQuestionFieldMutation, UpsertTranslatedQuestionFieldMutationVariables>;

/**
 * __useUpsertTranslatedQuestionFieldMutation__
 *
 * To run a mutation, you first call `useUpsertTranslatedQuestionFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTranslatedQuestionFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTranslatedQuestionFieldMutation, { data, loading, error }] = useUpsertTranslatedQuestionFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertTranslatedQuestionFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpsertTranslatedQuestionFieldMutation, UpsertTranslatedQuestionFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertTranslatedQuestionFieldMutation, UpsertTranslatedQuestionFieldMutationVariables>(UpsertTranslatedQuestionFieldDocument, options);
      }
export type UpsertTranslatedQuestionFieldMutationHookResult = ReturnType<typeof useUpsertTranslatedQuestionFieldMutation>;
export type UpsertTranslatedQuestionFieldMutationResult = Apollo.MutationResult<UpsertTranslatedQuestionFieldMutation>;
export type UpsertTranslatedQuestionFieldMutationOptions = Apollo.BaseMutationOptions<UpsertTranslatedQuestionFieldMutation, UpsertTranslatedQuestionFieldMutationVariables>;
export const UpsertTranslatedSupplementFieldDocument = gql`
    mutation UpsertTranslatedSupplementField($input: UpsertTranslatedSupplementFieldInput!) {
  upsertTranslatedSupplementField(input: $input) {
    errors {
      message
    }
  }
}
    `;
export type UpsertTranslatedSupplementFieldMutationFn = Apollo.MutationFunction<UpsertTranslatedSupplementFieldMutation, UpsertTranslatedSupplementFieldMutationVariables>;

/**
 * __useUpsertTranslatedSupplementFieldMutation__
 *
 * To run a mutation, you first call `useUpsertTranslatedSupplementFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTranslatedSupplementFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTranslatedSupplementFieldMutation, { data, loading, error }] = useUpsertTranslatedSupplementFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertTranslatedSupplementFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpsertTranslatedSupplementFieldMutation, UpsertTranslatedSupplementFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertTranslatedSupplementFieldMutation, UpsertTranslatedSupplementFieldMutationVariables>(UpsertTranslatedSupplementFieldDocument, options);
      }
export type UpsertTranslatedSupplementFieldMutationHookResult = ReturnType<typeof useUpsertTranslatedSupplementFieldMutation>;
export type UpsertTranslatedSupplementFieldMutationResult = Apollo.MutationResult<UpsertTranslatedSupplementFieldMutation>;
export type UpsertTranslatedSupplementFieldMutationOptions = Apollo.BaseMutationOptions<UpsertTranslatedSupplementFieldMutation, UpsertTranslatedSupplementFieldMutationVariables>;